var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgDots = function SvgDots(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#635F5F",
    d: "M4 13a3 3 0 1 1 0 6 3 3 0 0 1 0-6m12 0a3 3 0 1 1 0 6 3 3 0 0 1 0-6m12 0a3 3 0 1 1 0 6 3 3 0 0 1 0-6"
  })));
};
export default SvgDots;